// extracted by mini-css-extract-plugin
export default {"title":"SectionTitle_title__Yz1nC","center":"SectionTitle_center__AHqs7","right":"SectionTitle_right__iSCEr"};